/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Left_Candid_Zebra_FoldInputs */

const fr_left_candid_zebra_fold = /** @type {(inputs: Left_Candid_Zebra_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de visite moyen`)
};

/**

* @param {Left_Candid_Zebra_FoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const left_candid_zebra_fold = /** @type {((inputs?: Left_Candid_Zebra_FoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Left_Candid_Zebra_FoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_left_candid_zebra_fold(inputs)
});